import { render } from "./BlogArea.vue?vue&type=template&id=d7e105fe"
import script from "./BlogArea.vue?vue&type=script&lang=js"
export * from "./BlogArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__